if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          dots: this.querySelector(".fp-pdp__slider-buttons--bar"),
        };
        this.mql = window.matchMedia("(min-width: 768px)");

        window.addEventListener("orientationchange", () => {
          const currentMedia = this.elements.viewer.querySelector(".product__media-item.active");
          if (currentMedia) currentMedia.scrollIntoView();
        });

        this.elements.viewer.addEventListener("slideChanged", debounce(this.onSlideChanged.bind(this), 500));

        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll("[data-target]").forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector("button")
            .addEventListener("click", this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes("thumbnail") && this.mql.matches) this.removeListSemantic();
      }

      connectedCallback() {
        if (!this.elements.dots) return;

        const dot = this.elements.dots.querySelector(`[data-target]`);
        this.setActiveDot(dot);
      }

      onSlideChanged(event) {
        if (this.elements.thumbnails) {
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
          );
          this.setActiveThumbnail(thumbnail);
        }
        this.playActiveMedia(event.detail.currentElement);

        if (!this.elements.dots) return;

        const dot = this.elements.dots.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
        this.setActiveDot(dot);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector("[data-media-id]");
        if (!activeMedia) {
          return;
        }

        /* Reset pinch zoom */
        const activeMediaPinchZoom = activeMedia.querySelector("pinch-zoom");
        if (activeMediaPinchZoom) {
          activeMediaPinchZoom.style.setProperty("--x", "0");
          activeMediaPinchZoom.style.setProperty("--y", "0");
          activeMediaPinchZoom.style.setProperty("--scale", "1");
        }

        this.elements.viewer.querySelectorAll("[data-media-id]").forEach((element) => {
          element.classList.remove("is-active");
          element.classList.remove("active");
        });
        activeMedia?.classList?.add("is-active");
        activeMedia?.classList?.add("active");

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: "smooth" });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (this.elements.dots) {
          const activeDot = this.elements.dots.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveDot(activeDot);
        }
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      setActiveDot(dot) {
        if (!this.elements.dots || !dot) return;

        this.elements.dots.querySelectorAll("button").forEach((element) => {
          element.removeAttribute("aria-current");
          element.classList.remove("slider-counter__link--active");
        });
        dot.setAttribute("aria-current", true);
        dot.classList.add("slider-counter__link--active");
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(".product__modal-opener--image img");
        if (!image) return;
        image.onload = () => {
          if (this.elements.liveRegion) {
            this.elements.liveRegion.setAttribute("aria-hidden", false);
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position,
            );
            setTimeout(() => {
              this.elements.liveRegion.setAttribute("aria-hidden", true);
            }, 2000);
          }
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (!deferredMedia) return;

        if (deferredMedia.getAttribute("loaded")) {
          // Already loaded — resume playback if autoplay
          const video = deferredMedia.querySelector("video");
          if (video && deferredMedia.hasAttribute("data-autoplay")) {
            video.play();
          }
          return;
        }

        window.pauseAllMedia();
        deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute("role", "presentation"));
      }
    },
  );
}
